import { useEffect, useState } from "react";
import axios from "axios";
import "./AdminContact.css";

const Contact = () => {

    const [contacts,setContacts]=useState([]);

    useEffect(()=>{

        fetchContacts();

    },[]);

    const fetchContacts=async()=>{

        const res=await axios.get(
            "http://localhost/api/getContacts.php"
        );

        if(res.data.success){

            setContacts(res.data.data);

        }

    };

    const deleteContact=async(id)=>{

        if(!window.confirm("Delete this contact?")) return;

        const res=await axios.post(
            "http://localhost/api/deleteContact.php",
            {
                id:id
            }
        );

        alert(res.data.message);

        fetchContacts();

    };

    return(

<div className="admin-contact">

<h2>Contact Messages</h2>

<table>

<thead>

<tr>

<th>ID</th>
<th>Name</th>
<th>Email</th>
<th>Phone</th>
<th>Subject</th>
<th>Message</th>

<th>Date</th>
<th>Action</th>

</tr>

</thead>

<tbody>

{
contacts.map((item)=>(

<tr key={item.id}>

<td>{item.id}</td>

<td>{item.full_name}</td>

<td>{item.email}</td>

<td>{item.phone}</td>

<td>{item.subject}</td>

<td>{item.message}</td>



<td>{item.created_at}</td>

<td>

<button
className="delete-btn"
onClick={()=>deleteContact(item.id)}
>

Delete

</button>

</td>

</tr>

))
}

</tbody>

</table>

</div>

    );

};

export default Contact;